import { createSlice } from "@reduxjs/toolkit";

interface IState {
  visible: boolean;
}

const initialState: IState = {
  visible: true,
};

export const locationDataSlice = createSlice({
  name: "location-data",
  initialState,
  reducers: {
    toggleVisibility: (state) => {
      return { visible: !state.visible };
    },
    makeInvisible: (state) => {
      return { ...state, visible: false };
    },
  },
});

export const { toggleVisibility, makeInvisible } = locationDataSlice.actions;

export default locationDataSlice.reducer;
